import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import { Box, Button, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { TRACKING_CARD_SX } from "./trackingStyles";

const RequestExpertContactCard = ({ model }) => {
  const phone = model?.expertPhone;
  const telHref = phone ? `tel:${String(phone).replace(/\s/g, "")}` : undefined;

  return (
    <Box sx={{ ...TRACKING_CARD_SX, p: 2 }}>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1.5 }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            bgcolor: "primary.main",
            color: "primary.contrastText",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <AccountCircleOutlinedIcon />
        </Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="caption" color="text.secondary" display="block">
            کارشناس پرونده
          </Typography>
          <Typography variant="body1" fontWeight={700} noWrap>
            {model?.expertName || "—"}
          </Typography>
          {phone ? (
            <Typography variant="caption" fontFamily="monospace" color="text.secondary">
              {phone}
            </Typography>
          ) : null}
        </Box>
      </Stack>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<ChatOutlinedIcon />}
          fullWidth
          sx={{ borderRadius: 2 }}
          disabled
        >
          پیام به کارشناس
        </Button>
        <Button
          variant="contained"
          size="small"
          startIcon={<PhoneOutlinedIcon />}
          fullWidth
          component={telHref ? "a" : "button"}
          href={telHref}
          disabled={!telHref}
          sx={{ borderRadius: 2 }}
        >
          تماس با کارشناس
        </Button>
      </Stack>
    </Box>
  );
};

RequestExpertContactCard.propTypes = {
  model: PropTypes.object.isRequired,
};

export default RequestExpertContactCard;
